module.exports = __webpack_public_path__ + "img/thawte.b7f81923.png";